var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldBuildingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.25A2.25 2.25 0 012.25 0h8a2.25 2.25 0 012.25 2.25V7.5h1.25A2.25 2.25 0 0116 9.75v9.5a.75.75 0 01-.75.75H12.5v-3.75c0-.69-.56-1.25-1.25-1.25h-6.5c-.69 0-1.25.56-1.25 1.25V20H.75a.75.75 0 01-.75-.75v-17zM11 16.5V20H8.75v-3.5H11zm-3.75 0V20H5v-3.5h2.25zM3.5 4.5a1 1 0 102 0 1 1 0 00-2 0zm1 6a1 1 0 100 2 1 1 0 000-2zm0-3.5a1 1 0 100 2 1 1 0 000-2zM8 3.5a1 1 0 100 2 1 1 0 000-2zm0 7a1 1 0 100 2 1 1 0 000-2zm3.5 0a1 1 0 100 2 1 1 0 000-2zM8 7a1 1 0 100 2 1 1 0 000-2z",
    fill: "#333230"
  })));
}
export default SvgPldBuildingFilled;